import React from 'react';
import { connect } from 'react-redux';
import AppBaseComponent from '../../../components/AppBaseComponent';
import HttpAPICall from '../../../services/HttpAPICall';
import TapApiUrls, { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { Modal } from 'bootstrap';
import Ax from "../../../components/hoc/Ax";
import Loader from "../../../components/ui/Loader/Loader";
import moment from 'moment';
import DatePicker from "react-datepicker";
import tapIcon from '../../../services/TapIcon';
import TapSelect from '../../../components/ui/TapSelect';
import { toast } from 'react-toastify';
import swal from "sweetalert";
import uuid from 'react-uuid';

class CounterlogExecutionModal extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.executeFormInit = {

        }

        this.state = {
            execution_loading: false,
            selectedRowList: [],
            assetDetail: null,
            counterlog: null,
            executeForm: { ...this.executeFormInit },
            available_meters: [],
            isDisabled: false,
            latest_cl: [],
            form_data_loading: false,
            url     :   null,
            parameterOptions: [{ value: 'ok', label: 'Checked and OK' },
            { value: 'required_attention', label: 'May Required Attention' },
            { value: 'required_immediateattention', label: 'Required Immediate Attention' }],
        }
        this.counterlogExecutionModalId = uuid();
    }

    componentDidMount() {
        this.counterlogExecutionModal = new Modal(document.getElementById(this.counterlogExecutionModalId), { keyboard: false, backdrop: false });
    }

    executeCounterlogInit = (selectedRowList, assetDetail, counterlog, disabled = true,url) => {

        this.counterlogExecutionModal.show()
        this.loadFormData(selectedRowList, assetDetail, counterlog, disabled,url)

    }

    loadFormData = (selectedRowList, assetDetail, counterlog, disabled,url) => {
        this.setState({ form_data_loading: true })
        let params = { asset_id: assetDetail ? assetDetail.asset_id : '', counterlog_transaction_id: counterlog && counterlog.transaction_id? counterlog.transaction_id : '' }
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/scs/execution_form_data', this.props.access_token, { ...params }, {}, (resp) => {
            let respData = resp.data;
            let shiftReading = {};
            (respData.cl_data || []).forEach((meter) => {
                shiftReading[meter.key] =  meter.reading ;
            });
            this.setState({
                selectedRowList: selectedRowList,
                url         :   url ? url : null,
                assetDetail: respData.asset ? respData.asset : null,
                counterlog: counterlog ? counterlog : null,
                available_meters: respData && respData.available_meters ? respData.available_meters : [],
                latest_cl: respData && respData.latest_cl ? respData.latest_cl : [],
                shift_cl: respData && respData.cl_data ? respData.cl_data : [],
                isDisabled: disabled,
                executeForm: {
                            ...this.executeFormInit,
                            shift_reading: shiftReading,
                            date_time: respData.cl_data?.find(r => r.key === 'feed_datetime')?.reading ?? '',
                        }
            }, () => {
                console.log(this.state.executeForm,'ddd')
                this.setState({ form_data_loading: false })
                // if (respData.cl_data && respData.cl_data.length > 0) {
                //     let shiftReading = {};
                //     (respData.cl_data || []).forEach((meter) => {
                //         shiftReading[meter.key] = { ...meter };
                //     });

                //     this.setState({
                        
                //     });

                // }

                
            })

        }).then(() => this.setState({ listing_loading: false }));
    }

    handleCounterlogChange = (e) => {
        const { name, value } = e.target;

        this.setState(prevState => ({
            executeForm: {
                ...prevState.executeForm,
                shift_reading: {
                    ...prevState.executeForm.shift_reading,
                    [name]: value
                }
            }
        }));
    };



    handleDateChange = (date) => {
        this.setState(prevState => ({
            executeForm: {
                ...prevState.executeForm,
                date_time: moment(date).format('YYYY-MM-DD HH:mm:ss')
            }
        }));
    };

    submitExecuteFormHandler = (e) => {
        e.preventDefault();

        let asset_scs_setting_ids = this.state.selectedRowList.map((s, k) => s.id)

        let parameter = [];
        parameter = this.state.selectedRowList.filter(s => s.enable_parameter == "Y");

        let executeForm = { ...this.state.executeForm, date_time: moment(this.state.executeForm.date_time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') }
        
        let frmData = {
            scs_setting_ids: asset_scs_setting_ids,
            ...executeForm,
            parameter: parameter.length > 0
                ? parameter.map((p, key) => {
                    if (p.execute_level) {
                        return ({ scs_setting_id: p.id, execute_level: p.execute_level ? parseInt(p.execute_level) : null })
                    } else {
                        return ({ scs_setting_id: p.id, execute_val: p.execute_val ? p.execute_val : null })
                    }
                })
                : []
        };

        if (this.state.counterlog?.transaction_id) {
            frmData.counterlog_transaction_id = this.state.counterlog.transaction_id;
        }


        this.setState({ executeFormSubmitting: true })
        HttpAPICall.withAthorization('POST', this.state.url ? this.state.url : IAM_API_BASE_URL_2 + '/scs/execute_with_counterlog', this.props.access_token, {}, { ...frmData }, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            this.counterlogExecutionModal.hide()
            this.props.afterExecutionSubmit(asset_scs_setting_ids)

        }).then(() => this.setState({ executeFormSubmitting: false }));
    }

    render = () => {
        let labels = this.state.assetDetail && this.state.assetDetail.labels ? this.state.assetDetail.labels : {};

        return (
            <div className="modal fade" id={this.counterlogExecutionModalId} tabIndex="-1">
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">Execute Service 11 CheckSheet</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>

                        <div className="modal-body ">
                            {this.state.form_data_loading ? <><Loader /></>
                                : <>
                                    <table className="table table-bordered bg-white align-items-center  table-sm table-hover">
                                        <thead>
                                            <tr className="text-center">
                                                <th scope="col" style={{ width: "5%" }} >S.No</th>
                                                <th scope="col" >Service Checksheet Name</th>
                                                <th scope="col" style={{ width: "35%" }} >Parameter</th>
                                                <th scope="col" style={{ width: "25%" }} >Remarks</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.execution_loading
                                                ? <tr colSpan={2}><td className='text-center'><Loader /></td></tr>
                                                : this.state.selectedRowList && this.state.selectedRowList.length > 0 && this.state.selectedRowList.map(((sa, key) => {

                                                    return (<tr key={key + 1}>
                                                        <td className='text-center'>{key + 1}</td>
                                                        <td>{sa?.alias_name ? sa?.alias_name : "-"}</td>
                                                        <td>{sa.enable_parameter == "Y"
                                                            ? <div>{sa.parameter && sa.parameter.type == "range"
                                                                ? <span>
                                                                    <input
                                                                        type="number"
                                                                        className='form-control'
                                                                        name={"execute_level"}
                                                                        autoFocus={true}
                                                                        onChange={(e) => this.dynamicInputHandlerByKey(e, key, 'selectedRowList')}
                                                                        value={this.state.selectedRowList[key]?.execute_level}
                                                                        placeholder={`${sa.parameter.type_display ?? ""}`}
                                                                        style={{ height: "30px", fontSize: "93%" }} />
                                                                </span>
                                                                : <TapSelect
                                                                    changeEvent={(selectedOption) => {
                                                                        let selectedRowList = this.state.selectedRowList;
                                                                        selectedRowList[key] = { ...selectedRowList[key], execute_val: selectedOption ? selectedOption.value : '' };
                                                                        this.setState({ selectedRowList: [...selectedRowList] });

                                                                    }}

                                                                    options={this.state.parameterOptions}
                                                                    isClearable={true}
                                                                    autoFocus={true}
                                                                    value={this.state.parameterOptions.find(m => m.value == this.state.selectedRowList[key]?.execute_val)}
                                                                    placeholder="Please Select Options"
                                                                    containerHeight="30px"
                                                                    fontSize="93%"
                                                                />}</div>
                                                            : "-"}</td>
                                                        <td> <input
                                                            name="feedback_comment"
                                                            // className="form-control"
                                                            
                                                            className="form-control"
                                                            placeholder="Remarks"
                                                            
                                                        /></td>
                                                    </tr>)
                                                }))}
                                        </tbody>
                                    </table>
                                    <form onSubmit={this.submitExecuteFormHandler} id={`${this.counterlogExecutionModalId}Form`}>
                                        <div className='counterlog'>
                                            <div className="tab_content_wrapper">
                                                <span className="content_heading">Counterlog</span>
                                            </div>
                                            {this.state.available_meters.map((meter, i) => {
                                                let prevMeter = this.state.shift_cl
                                                    ? this.state.shift_cl.filter(r => r.key === meter.key)[0]
                                                    : null;
                                                let latestMeter = this.state.latest_cl
                                                    ? this.state.latest_cl.find(r => r.key === meter.key)
                                                    : null;

                                                const meterDef = this.state.shift_cl?.find(m => m.key === meter.key);

                                                return (
                                                    <div key={i} className="row my-2">
                                                        <label className="col-sm-3 text-sm require pt-2">
                                                            <b>{meter.label}</b> ({meter.unit})
                                                        </label>

                                                        <div className="col-sm-4">
                                                            <input
                                                                className="form-control"
                                                                disabled={this.state.isDisabled}
                                                                style={{ height: "30px", fontSize: "93%" }}
                                                                name={meter.key}
                                                                autoComplete='off'
                                                                 value={this.state.executeForm.shift_reading?.[meter.key]?? ''}
                                                                 onChange={this.handleCounterlogChange}

                                                            />


                                                        </div>
                                                        <label className="col-sm-5 form-text">
                                                            {latestMeter && JSON.stringify(latestMeter) !== JSON.stringify(prevMeter) && (
                                                                <small className="form-text">Latest Reading : {latestMeter.reading}</small>
                                                            )}
                                                        </label>


                                                    </div>
                                                );
                                            })}
                                            <div className="row my-2">
                                                <label className="col-sm-3 text-sm require pt-2">
                                                    <b>Counterlog Date</b></label>

                                                <div className="col-sm-4">
                                                    <DatePicker
                                                        selected={
                                                            this.state.executeForm && this.state.executeForm.date_time
                                                                ? moment(this.state.executeForm.date_time).toDate()
                                                                : null
                                                        }
                                                        onChange={this.handleDateChange}
                                                        name="date_time"
                                                        className={"form-control"}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        autoComplete="off"
                                                        scrollMonthYearDropdown
                                                        placeholderText="Please Select Counterlog Date"
                                                        showTimeSelect
                                                        timeIntervals={5}
                                                        timeCaption="Time"
                                                        required={true}
                                                        popperPlacement="right-start"
                                                        dateFormat="dd-MMM-yyyy hh:mm a"
                                                        disabled={this.state.isDisabled}
                                                    />



                                                </div>


                                                <label className="col-sm-5 form-text">
                                                    {
                                                        this.state.latest_cl?.find(r => r.key === 'feed_datetime')?.reading &&
                                                        <small className="form-text">
                                                            Latest Reading: {moment(this.state.latest_cl.find(r => r.key === 'feed_datetime').reading).format('DD-MMM-YYYY hh:mm A')}
                                                        </small>
                                                    }
                                                </label>

                                            </div>

                                        </div>

                                    </form>
                                </>}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" disabled={this.state.executeFormSubmitting} data-bs-dismiss="modal" >Cancel</button>
                            <button type="button" className="btn btn-primary" disabled={this.state.executeFormSubmitting} form={`${this.counterlogExecutionModalId}Form`} onClick={(e) => this.submitExecuteFormHandler(e)}>Update {this.state.executeFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}</button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token
    };
};


export default connect(mapStateToProps, null, null, { forwardRef: true })(CounterlogExecutionModal);